import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import queryString from 'qs';

import config from '@/config';
import { getAccessToken } from '@/shared/services/accessToken';
import { joinBaseUrl, isAbsoluteUrl } from '@/shared/utils/url';

export enum RequestMethod {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	PATCH = 'PATCH',
	DELETE = 'DELETE',
}

const buildRequestUrl = (url: string) => {
	if (isAbsoluteUrl(url)) {
		return url;
	}

	return encodeURI(joinBaseUrl(config.api_url, url));
};

export async function processRequest(
	url: string = '',
	method: RequestMethod = RequestMethod.GET,
	data: Record<string, any> | FormData = {},
	additionalHeaders: Record<string, string> = {},
): Promise<AxiosResponse<any>> {
	const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
	const hasAuthorizationHeader = additionalHeaders.Authorization != null || additionalHeaders.authorization != null;
	let headers: Record<string, string> = {
		...additionalHeaders,
	};

	if (!isFormData && method !== RequestMethod.GET) {
		headers['Content-Type'] = headers['Content-Type'] || 'application/json';
	}

	const token = getAccessToken();

	if (token && !hasAuthorizationHeader) {
		headers.Authorization = `Bearer ${token}`;
	}

	if (isFormData && headers['Content-Type']) {
		delete headers['Content-Type'];
	}

	const shouldSendCredentials = headers.Authorization == null && headers.authorization == null;

	const requestConfig: AxiosRequestConfig = {
		headers,
		method,
		params: method === RequestMethod.GET ? data : {},
		data: method === RequestMethod.GET ? undefined : data,
		url: buildRequestUrl(url),
		withCredentials: shouldSendCredentials,
		paramsSerializer: (params) => queryString.stringify(params, { arrayFormat: 'brackets' }),
	};

	return axios(requestConfig);
}
